










// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';

// Components
import ItemThumb, {
  ItemThumbPrefeginedStyle,
  TittleFontFamily,
  SubtitleFontFamily,
} from '@/shared/components/item-thumb.component.vue';
import RangeSlider from '@/shared/components/range-slider.component.vue';
import Field from '@/shared/components/field.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import FloatMenu, {
  FloatMenuPosition,
} from '@/shared/components/float-menu.component.vue';
import MenuElement, {
  MenuElementBgColor,
  MenuElementSize,
} from '@/shared/components/menu-element.component.vue';

// Views
import ChooseConvocation from '@/client/budget/views/acceptance/choose-fees/choose-convocation/index.vue';

// Models
import { LastRequest } from '@/manager/budget/models/budget.model';
import { BudgetFee } from '@/manager/budget/models/budget-fee.model';
import { Product, Branch } from '@/manager/product/models/product.model';
import { FeeInterface } from '@/clickbuy/purchase/models/fee.interface';

// Filters
import round from '@/shared/filters/round.filter.ts';
import formatDate from '@/shared/filters/formatDate.filter.ts';

@Component({
  components: {
    ItemThumb,
    Field,
    RangeSlider,
    ChooseConvocation,
    Icon,
    FloatMenu,
    MenuElement,
  },
  computed: {
    ...mapGetters({
      currentBudget: 'getCurrentBudgetAcceptance',
      budgetConvocations: 'getCurrentBudgetAcceptanceConvocationFiltered',
      convocationListSelected: 'getCurrentBudgetAcceptanceSelectedConvocations',
      acceptanceProductList: 'getCurrentBudgetAcceptanceProductList',
      getConvocationList: 'getCurrentBudgetAcceptanceConvocationByProduct',
      getProductListByBranch: 'getCurrentBudgetAcceptanceBranchProductList',
      acceptanceProductListContained:
        'getCurrentBudgetAcceptanceProductListContained',
      acceptanceProductListByLevel:
        'getCurrentBudgetAcceptanceProductListByLevel',
      acceptanceDelegationList: 'getCurrentBudgetAcceptanceDelegationList',
      getDiscountSoonPayment: 'getCurrentBudgetAcceptanceDiscountSoonPayment',
      feeList: 'getFeeList',
      budgetProductsPack: "budgetProductsPack",
    }),
  },
  methods: {
    ...mapActions({
      setCurrentBudgetAcceptance: 'setCurrentBudgetAcceptance',
    }),
  },
  filters: {
    round,
    formatDate,
  },
})
export default class ChooseFees extends Vue {
  private menuElementSize = MenuElementSize;
  private iconEnum = IconEnum;
  private menuElementBgColor = MenuElementBgColor;
  private floatMenuPosition = FloatMenuPosition;
  private tittleFontFamily = TittleFontFamily;
  private subtitleFontFamily = SubtitleFontFamily;
  private feeList!: any;
  private convocationListSelected!: any;
  private currentBudget!: any;
  private budgetConvocations!: any;
  private setCurrentBudgetAcceptance!: any;
  private requestTimeout!: any;
  private getDiscountSoonPayment!: any;
  private getProductListByBranch!: any;
  private acceptanceDelegationList!: any;
  private getConvocationList!: any;
  private acceptanceProductList!: any;
  private acceptanceProductListContained!: any;
  private acceptanceProductListByLevel!: any;
  private acceptanceProductListByLevels!: any;
  private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
  private serverError = '';
  private numberOfFees = 1;
  private userChangeFees = false;
  private budgetProductsPack: any;
  private literals = {
    fees: {
      title: 'Número de cuotas',
      subtitle:
        'Selecciona el número de cuotas en las que te gustaría pagar esta alta. ' +
        'En la parte de la derecha podrás comprobar las fechas de pago junto con la cuantía de cada cuota.',
    },
    itinerary: {
      title: 'Itinerario Formativo',
      subtitle:
        'Selecciona a qué convocatorias te gustaría asistir en ' +
        'función de las provincias que has elegido. Ten en cuenta que tus cuotas ' +
        'podrían variar en función del itinerario formativo que elijas.',
    },
    leaderShipBranch: 'Desarrollo empresarial',
    businessBranch: 'Desarrollo liderazgo',
    noBranch: 'Especialización',
    helpTextRange:
      'Selecciona el número de cuotas utilizando el control deslizante',
  };
  @Prop() private pack!: any;

  private created() {
    this.initializeComponent();
  }

  @Watch('numberOfFees')
  private watchNumberOfFee(newVal: number, oldVal: number) {
    this.currentBudget.numberOfFees = newVal;
    if (oldVal !== undefined) {
      if (this.userChangeFees) {
        this.retrievePaymentDates(newVal);
      }
      this.userChangeFees = false;
    }
  }

  // TODO - Este método existe en el store, pero se produce un fallo en la reactividad tras cambiar las cuotas
  get discountSoonPayment() {
    let discount = 0;
    if (this.isSoonPayment) {
      this.acceptanceProductList.map((product: any) => {
        const productDiscount = product.discountSoonPayment;
        if (discount < productDiscount) {
          discount = productDiscount;
        }
      });
    }
    return discount;
  }

  get isSoonPayment() {
    return this.numberOfFees === 1;
  }

  get feePrice() {
    const totalPrice = this.currentBudget.totalPrice;
    return (totalPrice - this.discountSoonPayment) / this.numberOfFees;
  }

  get delegationListIds() {
    return this.acceptanceDelegationList.map(
      (delegation: any) => delegation.id,
    );
  }

  get hasBranchCourses() {
    let allCourses = 0;
    this.acceptanceProductList.forEach((rootProduct: any) => {
      allCourses += this.leaderShipBranchProducts(rootProduct).length;
      allCourses += this.businessProducts(rootProduct).length;
    });
    return allCourses > 0;
  }

  get hasLeaderShipCourses() {
    let allCourses = 0;
    this.acceptanceProductList.forEach((rootProduct: any) => {
      allCourses += this.leaderShipBranchProducts(rootProduct).length;
    });
    return allCourses > 0;
  }

  get hasBusinessCourses() {
    let allCourses = 0;
    this.acceptanceProductList.forEach((rootProduct: any) => {
      allCourses += this.businessProducts(rootProduct).length;
    });
    return allCourses > 0;
  }

  get hasNoBranchCourses() {
    let allCourses = 0;
    this.acceptanceProductList.forEach((rootProduct: any) => {
      allCourses += this.noBranchCourses(rootProduct).length;
    });
    return allCourses > 0;
  }

  private calculateBudgetAcceptance(data: any = { fee_number: 1 }) {
    return this.$store.dispatch('calculateBudgetAcceptance', {
      budgetId: this.currentBudget.id,
      delegation: this.delegationListIds,
      convocation: this.convocationListSelected,
      ...data,
    });
  }

  private initializeComponent() {
    this.numberOfFees = this.currentBudget.numberOfFees || 1;
    this.fetchBudgetProductsPack()
  }

  private leaderShipBranchProducts(product: Product) {
    return this.getProductListByBranch(product.id, Branch.Leadership);
  }

  private businessProducts(product: Product) {
    return this.getProductListByBranch(product.id, Branch.Business);
  }

  private noBranchCourses(product: Product) {
    return this.getProductListByBranch(product.id, null);
  }

  private getConvocations(product: Product) {
    return this.getConvocationList(product.id);
  }

  private fetchBudgetProductsPack() {
    this.$store.dispatch('fetchBudgetProductsPack', { id: this.currentBudget.id })
  }

  private coursesByLevel(product: Product, level: number) {
    return this.acceptanceProductListByLevel(product.id, level);
  }

  private coursesByLevels(product: Product) {
    return this.acceptanceProductListContained(product.id);

  }

  private rangeSlides(value: number) {
    this.userChangeFees = true;
    this.currentBudget.lastRequest = LastRequest.NumberFees;
    this.setCurrentBudgetAcceptance(this.currentBudget);
  }

  private async retrievePaymentDates(numberOfFees: number) {
    clearTimeout(this.requestTimeout);

    this.requestTimeout = setTimeout(async () => {
      await this.calculateBudgetAcceptance({
        feeNumber: numberOfFees,
      });
    }, Constants.searchEmitTime);
  }
}
